import Ping from 'react-native-ping';

export const isRobotAccessible = async (robotIp: string | undefined) => {
  if (robotIp) {
    const host = robotIp.split(':', 1)[0];

    return await Ping.start(host, { timeout: 1000 })
      .then((res: any) => res > 0)
      .catch(() => false);
  } else {
    return false;
  }
};
